import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TopbarComponent } from "./navigation/topbar.component";

@Component({
  selector: "app-platform",
  template: `
    <pienso-topbar />
    <div class="content">
        <router-outlet></router-outlet>
    </div>
  `,
  styles: [`:host { display: contents; } .content { display: block; overflow: hidden; flex: auto; min-height: 0;}`],
  imports: [TopbarComponent, RouterOutlet],
})
export class PlatformComponent {}
